import { Box, Typography } from '@mui/material';

const PromotionConditions = ({ promotion }) => {
    if (!promotion?.promo || !promotion.description) return null;
    return (
        <Box sx={{ mt: 1.5, p: 1.5, borderLeft: '3px solid', borderColor: 'primary.main', bgcolor: '#f4faf7', borderRadius: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>Promoción destacada</Typography>
            <Typography variant="body2">{promotion.description}</Typography>
            <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 0.5, mb: 0 }}>
                El descuento se aplica al cumplir los requisitos. La promoción destacada se determina según tus cantidades y no se acumulan promociones.
            </Typography>
        </Box>
    );
};

export default PromotionConditions;
